import { Heading, Text } from '@lmc/ui-kit/src/general'
import type { ComponentProps, FC, HTMLAttributes } from 'react'
import styled from 'styled-components'

interface TextareaWrapperProps extends HTMLAttributes<HTMLDivElement> {
  $withNotesLabel?: boolean
}

export const FormCardHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
` as FC<ComponentProps<typeof Heading>>

export const NotesBlock = styled.div`
  display: flex;
  flex-direction: column;
` as FC<HTMLAttributes<HTMLDivElement>>

export const NotesLabel = styled(Text)`
  font-size: 15px;
  color: ${({ theme }) => theme.color.neutral.color3};
  margin-bottom: 0;
` as FC<ComponentProps<typeof Text>>

export const NotesText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
  white-space: pre-wrap;
  margin-top: 4px;
` as FC<ComponentProps<typeof Text>>

export const TextareaWrapper = styled.div<{ $withNotesLabel?: boolean }>`
  margin-top: ${({ $withNotesLabel }) => ($withNotesLabel ? 8 : 0)}px;

  > div {
    min-height: 0 !important;
    margin-top: 0 !important;
    padding: 0 !important;
  }

  > div > div {
    min-width: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  textarea {
    margin-top: 0 !important;
  }
` as FC<TextareaWrapperProps>
